export const healthMeasures: Record<string, [string, string, number, number]> = {
  "weightLb": [
    "Weight",
    "lb",
    30,
    1500
  ],
  "bodyFatPct": [
    "Body fat",
    "%",
    1,
    75
  ],
  "fatMassLb": [
    "Fat mass",
    "lb",
    0,
    1000
  ],
  "skeletalMuscleLb": [
    "Skeletal muscle",
    "lb",
    1,
    400
  ],
  "muscleMassLb": [
    "Muscle mass",
    "lb",
    1,
    800
  ],
  "leanMassLb": [
    "Lean body mass",
    "lb",
    1,
    800
  ],
  "waistIn": [
    "Waist",
    "in",
    10,
    100
  ],
  "bodyWaterPct": [
    "Body water",
    "%",
    1,
    90
  ],
  "boneMassLb": [
    "Bone mass",
    "lb",
    0,
    30
  ],
  "visceralFat": [
    "Visceral fat level",
    "level",
    0,
    100
  ],
  "bmr": [
    "BMR",
    "kcal",
    400,
    5000
  ],
  "bmi": [
    "BMI",
    "",
    5,
    100
  ],
  "subcutaneousFatPct": [
    "Subcutaneous fat",
    "%",
    0,
    75
  ],
  "proteinPct": [
    "Protein",
    "%",
    0,
    50
  ],
  "skeletalMusclePct": [
    "Skeletal muscle",
    "%",
    0,
    80
  ],
  "metabolicAge": [
    "Metabolic age",
    "years",
    1,
    120
  ]
};
